function AskPaperMessageLoading() {
  return (
    <div className="flex flex-col w-full gap-2 p-5 mr-auto bg-bg-faint rounded-xl">
      <div className={"bg-border-base animate-pulse h-2.5 rounded-xl w-full"} />
      <div
        className={"bg-border-base animate-pulse h-2.5 rounded-xl w-[60%]"}
      />
      <div
        className={"bg-border-base animate-pulse h-2.5 rounded-xl w-[80%]"}
      />
      <div className={"bg-border-base animate-pulse h-2.5 rounded-xl w-full"} />
      <div
        className={"bg-border-base animate-pulse h-2.5 rounded-xl w-[80%]"}
      />
    </div>
  );
}

export default AskPaperMessageLoading;
